import { FC, memo } from "react"

interface HintProps {
    children: React.ReactNode;
    className?: string;
}

const Hint: FC<HintProps> = ({ children, className }) => {
    return (
        <div className={`text-sm text-gray-500 ${className}`}>
            {children}
        </div>
    )
}

export default memo(Hint)

